import auth from "@/auth.js";

export default {
  [auth.roles.USER]: [
    {
      title: "Projects",
      action: "folder",
      subItems: [
        { text: "Проекти", routeName: "projectsProjects" },
        { text: "Задачи", routeName: "projectsIssues" },
      ],
    },
  ],
  [auth.roles.ADMINISTRATOR]: [
    {
      title: "Projects",
      action: "folder",
      subItems: [
        { text: "Проекти", routeName: "projectsProjects" },
        { text: "Задачи", routeName: "projectsIssues" },
      ],
    },
  ],
  [auth.roles.SALES_MANAGER]: [],
  [auth.roles.ACCOUNT_MANAGER]: [],
  [auth.roles.ACCOUNT_CLIENT]: [],
};